import type { Fundadora } from '@/types/member';

export const FUNDADORAS: Fundadora[] = [
  {
    id: 'fundadora-belli-ramirez',
    display_name: 'Belli Ramírez',
    city: '',
    country: 'España',
    biography:
      'Belli Ramírez, es un referente de la dirección de producción en proyectos de animación en España. Belli cuenta con 30 años de experiencia gestionando películas y series de televisión.\nHa tenido la oportunidad de ampliar su experiencia trabajando para un gran número de productoras de animación, de la cuales cabe destacar la ganadora de un Oscar Animal Logic en Sydney, Australia, Ilion Animation Studios, donde ejerció como jefa de la unidad de Producción en la película Planet 51 y como jefa de Producción en la primera y cuarta temporada de Pocoyo, una de las series de tv más reconocidas internacionalmente.\nEn la actualidad Belli es fundadora y consultora en Mr. Cohl, donde colabora en el desarrollo de proyectos de animación. Son varios los clientes para los que suele trabajar, entre ellos: Zinkia, Hampa, MediaPro, Grupo Caribe, Fernando Trueba PC, WarnerBros, Inicia Films y Atlántika films entre otros. Compagina la consultoría, la dirección de producción y la formación. En este último ámbito es profesora asociada en La UPV, Escuela TAI, y en Universidad Pompeu Fabra de Barcelona.\nBelli es socia fundadora de Mia, Mujeres en la industria de la animación y miembro de la Academia de las Artes y las Ciencias Cinematográficas de España.\n\nRoles en junta: Presidenta provisional',
    profile_image_url: '/images/fundadoras/belli-ramirez.webp',
    social_media: {
      instagram: 'https://instagram.com/belliramirez',
      linkedin: 'https://www.linkedin.com/in/belliramirez/',
    },
    main_profession: 'Dirección de producción',
    other_professions: ['Producción', 'Producción ejecutiva'],
    is_founder: true,
  },
  {
    id: 'fundadora-myriam-ballesteros',
    display_name: 'Myriam Ballesteros',
    city: '',
    country: 'España',
    biography:
      'Myriam Ballesteros es creadora, directora y productora de destacadas series y cortos de animación para el público infantil y juvenil. Fundadora de MB Producciones e IMIRA Entertainment, ha sido showrunner, story editor y directora creativa de éxitos internacionales como Lucky Fred, Sandra, detective de cuentos, Lola & Virginia o Meme y el Sr. Bobo, vendidas en más de 100 países y premiadas en festivales como CIFF, Annecy o Cartoon on the Bay.\n\nLicenciada en Periodismo y especializada en cine y animación en NYU, BBC y EAVE, ha dirigido también cortos como La superrabieta o Cenicienta Swing, y desarrolla actualmente las series Annie & Carola y Cenicienta Enmascarada.\n\nEstá también preparando su primer largometraje, Amalur Profezia, una aventura épica protagonizada por una adolescente con poderes mágicos y una gamer brillante que viajan a un mundo mitológico para derrotar al Señor de las Tinieblas.\n\nHa sido fundadora y presidenta de MIA, impulsando la visibilidad y el liderazgo de las mujeres en la animación.\n\nRoles en junta: fundadora, vocal y presidenta',
    profile_image_url: '/images/fundadoras/myriam-ballesteros.webp',
    social_media: {
      website: 'https://mbproducciones.com/',
      linkedin: 'https://www.linkedin.com/in/myriamballesteros/',
      instagram: 'https://www.instagram.com/mb_produ/',
    },
    main_profession: 'Dirección',
    other_professions: ['Guión', 'Producción ejecutiva', 'Dirección'],
    is_founder: true,
  },
  {
    id: 'fundadora-alicia-nunez-puerto',
    display_name: 'Alicia Núñez Puerto',
    city: '',
    country: 'España',
    biography:
      'Directora y productora nominada a los Goya con 20 años de experiencia, miembro numerario de la Academia de Cine de España y Andalucía, Alicia ha trabajado en más de 30 grandes producciones para compañías como Aardman Animations, BRB Internacional o Ánima Estudios.\n\nHa dirigido dos cortometrajes "LA PRIMAVERA SIEMPRE VUELVE" y "ONE WAY CYCLE" con los que ha obtenido selecciones y premios en festivales de todo el mundo. Es miembro de MIA, AAMMA, DAMA, Egeda y La coordinadora del cortometraje.\n\nActualmente, Alicia es VP de Desarrollo Creativo de Ánima Estudios, es co-productora ejecutiva de "BATMAN AZTECA", de WB y prepara su primer largometraje como directora.\n\nRoles en junta: Secretaria. Noviembre 2018 a septiembre 2019. // Presidenta. De septiembre 2019 a enero 2021. // Vocal. Desde julio 2025.',
    profile_image_url: '/images/fundadoras/alicia-nunez-puerto.webp',
    social_media: {
      instagram: 'https://www.instagram.com/aliolinu/',
      linkedin: 'https://www.linkedin.com/in/alicianunezpuerto/',
    },
    main_profession: 'Dirección',
    other_professions: ['Producción ejecutiva', 'Dirección'],
    is_founder: true,
  },
  {
    id: 'fundadora-dune-blanco',
    display_name: 'Dune Blanco',
    city: '',
    country: 'España',
    biography:
      'Dune lleva dedicándose al Desarrollo Visual y Creativo para Animación y Videojuegos por más de 10 años. Ha trabajado para productoras como CARTOON NETWORK, CANAL+, ÁNIMA ESTUDIOS, BRB Internacional, TOMAVISTAS, TOONZ, LIGHTBOX, SOCIAL POINT, IGG…\nTrabajó para ÁNIMA ESPAÑA realizando el desarrollo inicial y posteriormente el Diseño de Producción de la serie PINY Institute of New York, emitida en Disney Channel.\nFundadora de MIA (Asociación de Mujeres en la Industria de la Animación), junto a otras compañeras de profesión (2018).\n\nRoles en junta: Vocal',
    profile_image_url: '/images/fundadoras/dune-blanco.webp',
    social_media: {
      linkedin: 'https://www.linkedin.com/in/duneblanco/',
      instagram: 'https://www.instagram.com/mrklaus_studio/',
      website: 'http://www.mrklausstudio.com/demo-reel/',
    },
    main_profession: 'Visual Development',
    other_professions: ['Concept Art', 'Diseño de personajes', 'Visual Development'],
    is_founder: true,
  },
  {
    id: 'fundadora-elena-gobernado-santos',
    display_name: 'Elena Gobernado Santos',
    city: '',
    country: 'España',
    biography:
      'Elena Gobernado cuenta con más de 25 años de experiencia en el ámbito audiovisual, está especializada en el desarrollo literario de proyectos audiovisuales como guionista, coordinadora, script editor y asesora.',
    profile_image_url: '/images/fundadoras/elena-gobernado-santos.webp',
    social_media: {},
    main_profession: 'Guión',
    other_professions: ['Guión'],
    is_founder: true,
  },
  {
    id: 'fundadora-tania-palma',
    display_name: 'Tania Palma',
    city: '',
    country: 'España',
    biography:
      'Tania Palma es directora de producción y productora ejecutiva de animación.\n\nRoles en junta: Secretaría (2021 - 2023)',
    profile_image_url: '/images/fundadoras/tania-palma.webp',
    social_media: {},
    main_profession: 'Dirección de producción',
    other_professions: ['Producción', 'Producción ejecutiva'],
    is_founder: true,
  },
  {
    id: 'fundadora-deneb-sabater-ventura',
    display_name: 'Deneb Sabater Ventura',
    city: '',
    country: 'España',
    biography:
      'Deneb Sabater Ventura, inicia su andadura profesional en el sector de la animación en un entrañable estudio de animación en Valencia.\n\nRoles en junta: Vicepresidente y Tesorera 2018-2021',
    profile_image_url: '/images/fundadoras/deneb-sabater-ventura.webp',
    social_media: {
      linkedin: 'https://www.linkedin.com/in/denebsabater/',
      instagram: 'https://www.instagram.com/denebestrela/',
    },
    main_profession: 'Producción',
    other_professions: ['Producción'],
    is_founder: true,
  },
];
